import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import api from "@/lib/api";
import Seo from "@/components/Seo";
import FreeGuideSignup from "@/components/FreeGuideSignup";

const DEFAULT_COVER = "https://images.unsplash.com/photo-1505128798310-612a1f29c071?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";
const PERKS = [
  "Design a clean workspace on any budget",
  "The exact gear list (still-air box, flow hood & alternatives)",
  "Sterilization & airflow that actually prevents contamination",
  "Step-by-step lab layout from kitchen-counter to pro",
];

export default function FreeGuide() {
  const [info, setInfo] = useState({ title: "Build Your Own Mycology Lab", cover: "" });
  useEffect(() => {
    api.get("/free-guide/info").then((r) => setInfo(r.data)).catch(() => {});
  }, []);
  const cover = info.cover || DEFAULT_COVER;

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16" data-testid="free-guide-page">
      <Seo title="Free Guide" path="/free-guide"
        description="Get Build Your Own Mycology Lab — a $100 value, free. Join the NC Mycology email list and we'll send the download." />
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <motion.div initial={{ opacity: 0, x: -24 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}>
          <span className="inline-block font-mono-label text-[10px] text-primary border border-primary/40 rounded-full px-3 py-1 mb-5">
            Free · $100 Value
          </span>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05]">{info.title}</h1>
          <p className="text-base text-muted-foreground mt-5 max-w-md leading-relaxed">
            The complete blueprint to set up your own contamination-free mushroom lab at home — the same
            system we use. Normally a $100 guide, yours free when you join our list.
          </p>
          <ul className="mt-7 space-y-2.5 mb-8">
            {PERKS.map((p) => (
              <li key={p} className="flex items-start gap-3 text-sm">
                <Check className="w-4 h-4 text-primary shrink-0 mt-0.5" /> <span>{p}</span>
              </li>
            ))}
          </ul>
          <FreeGuideSignup variant="full" />
        </motion.div>

        <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="relative">
          <div className="absolute -inset-3 bg-primary/10 blur-2xl -z-10" aria-hidden="true" />
          <img src={cover} alt={info.title} className="w-full aspect-[4/5] object-cover border border-border rounded-sm shadow-2xl" />
          <div className="absolute bottom-4 left-4 bg-primary text-primary-foreground font-mono-label text-[10px] px-3 py-1.5 rounded-full">
            FREE DOWNLOAD
          </div>
        </motion.div>
      </div>
    </div>
  );
}
